// @ts-expect-error exisits in the browser
export const AvailableTimezones = ['UTC', ...Intl.supportedValuesOf('timeZone')];
